module.exports = __webpack_public_path__ + "static/media/header4.a2a53835.gif";